// ----------------------------------------------------------------------
// <copyright file="Izenda.Confirmation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------



/**
 * @module: Confirmation Component
 *  <Confirmation showCancel={true|false} 
 *    type={'confirm'|'warning'|'error'} 
 *    message='This is the title' 
 *    description='This is description of confirm' >
 *  </Confirmation>
 *
 */
!(function () {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var classnames = require('classnames');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var localizer = require('share/localization/Izenda.Localizer');
  var GroupRadioInput = require('share/components/controls/Izenda.GroupRadioInput');

  var CONFIRMATION_MESSAGE_MAX_LENGTH = 1000;
  const { noop, isNil, isFunction, truncate, isObject } = require('lodash/fp');
  var Confirmation = React.createClass({
    propTypes: {
      confirmLabel: React.PropTypes.string,
      abortLabel: React.PropTypes.string,
      showCancel: React.PropTypes.bool,
      type: React.PropTypes.string,
      showCloseIndicator: React.PropTypes.bool,
      onAccept: React.PropTypes.func.isRequired,
      onReject: React.PropTypes.func.isRequired,
      style: React.PropTypes.object,
      showRadio: React.PropTypes.bool,
      radioOptions: React.PropTypes.array,
      radioValue: React.PropTypes.string,
    },
    getDefaultProps: function () {
      return {
        confirmLabel: null,
        abortLabel: null,
        showCancel: true,
        type: 'confirm',
        showCloseIndicator: false,
        onAccept: noop,
        onReject: noop,
        isHTMLFormat: false,
        showRadio: false,
        radioOptions: [],
        radioValue: ''
      };
    },

    getInitialState: function () {
      return {
        radioValue: this.props.radioValue
      }
    },

    componentDidMount: function () {
      var type = this.props.type;
      if (
        type !== commonMessages.MESSAGE_TYPE.INFO &&
        type !== commonMessages.MESSAGE_TYPE.ERROR &&
        type !== commonMessages.MESSAGE_TYPE.WARNING
      ) {
        this.props.showCancel
          ? ReactDOM.findDOMNode(this.refs.cancelButton).focus()
          : ReactDOM.findDOMNode(this.refs.acceptButton).focus();
      }
      window.onkeyup = this.onEscape;
    },

    componentWillUnmount: function () {
      window.onkeyup = null;
    },

    rawMarkup: function (string) {
      return { __html: string };
    },

    onPopupClosed: function (type) {
      if (type === 'accept' && isFunction(this.props.onAccept)) {
        if (this.props.showRadio) {
          this.props.onAccept(this.state.radioValue);
        } else {
          this.props.onAccept();
        }
      } else if (type === 'cancel' && isFunction(this.props.onReject)) {
        this.props.onReject();
      }
    },

    onPopupAccept: function () {
      this.onPopupClosed('accept');
    },

    onEscape: function (e) {
      e.keyCode === 27 && this.onPopupClosed('cancel');
      e.keyCode === 13 && this.onPopupClosed('accept');
    },

    render: function () {
      var renderCloseIndicator = function () {
        var classes = classnames('icon-cancel', 'close-indicator');
        if (this.props.showCloseIndicator) {
          return (
            <div className='izenda-Confirmation-close'>
              <span onClick={this.onPopupAccept} className={classes} />
            </div>
          );
        }
        return null;
      }.bind(this);

      var renderMessageBody = function () {
        var description = getDescription();
        var isHTMLFormat = this.props.isHTMLFormat;
        if (isHTMLFormat) {
          return (
            <div className='izenda-Confirmation-content description'>
              <div dangerouslySetInnerHTML={this.rawMarkup(description)} />
            </div>
          );
        } else {
          var descriptionTruncate = truncate(
            {
              length: CONFIRMATION_MESSAGE_MAX_LENGTH,
              separator: ' ',
              omission: '...'
            },
            description
          );

          return (
            <div className='izenda-Confirmation-content'>
              <span title={description} className='u_textBreak'>
                {descriptionTruncate}
              </span>
            </div>
          );
        }
      }.bind(this);

      var getDescription = function () {
        let description = this.props.description;
        if (isObject(description) && description.messages.length > 0)
          return description.messages[0].messages;
        return isObject(description) ? localizer.getText('COMMON_MESSAGES_GENERIC_ERROR') : description;
      }.bind(this);

      var renderRadioInput = function () {
        const { showRadio, radioOptions } = this.props;

        var onRadioOptionChange = function (value) {
          this.setState({ radioValue: value.value });
        }.bind(this);

        if (!showRadio) {
          return null;
        }
        return (<GroupRadioInput
          onChange={onRadioOptionChange}
          value={this.state.radioValue}
          options={radioOptions}
        />)
      }.bind(this);

      var iconMessageClass = classnames('confirm-message-icon', {
        'icon-help-circled confirm': this.props.type === 'confirm',
        'icon-attention-circled warning': this.props.type === commonMessages.MESSAGE_TYPE.WARNING,
        // 'icon-info-circled info': this.props.type === commonMessages.MESSAGE_TYPE.INFO,
        'icon-info-circled info': this.props.type === commonMessages.MESSAGE_TYPE.INFO_ACCEPT,
        'icon-error-circled error': this.props.type === commonMessages.MESSAGE_TYPE.ERROR
      });

      return (
        <Popup visible onClosed={this.onPopupClosed} type={this.props.type} style={this.props.style}>
          <Popup.Body>
            <div className='izenda-Confirmation'>
              <div className='izenda-Confirmation-icon'>
                <span className={iconMessageClass} />
              </div>
              {renderMessageBody()}
              {renderRadioInput()}
              {renderCloseIndicator()}
            </div>
          </Popup.Body>
          {this.renderFooter()}
        </Popup>
      );
    },

    renderFooter: function () {
      var props = this.props;
      var confirmLabel = isNil(props.confirmLabel) ? localizer.getText('COMMON_LABEL_OK') : props.confirmLabel;
      var abortLabel = isNil(props.abortLabel) ? localizer.getText('COMMON_LABEL_CANCEL') : props.abortLabel;

      var renderAccept = function () {
        if (!this.props.showCloseIndicator) {
          return (
            <Popup.ConfirmationButton ref='acceptButton' type='accept'>
              {confirmLabel}
            </Popup.ConfirmationButton>
          );
        }
        return null;
      }.bind(this);

      var renderCancel = function () {
        if (this.props.showCancel) {
          return (
            <Popup.ConfirmationButton ref='cancelButton' type='cancel'>
              {abortLabel}
            </Popup.ConfirmationButton>
          );
        }
        return null;
      }.bind(this);

      var type = this.props.type;
      if (type !== commonMessages.MESSAGE_TYPE.INFO && type !== commonMessages.MESSAGE_TYPE.ERROR) {
        return (
          <Popup.Footer>
            {renderAccept()}
            {renderCancel()}
          </Popup.Footer>
        );
      }
      return null;
    }
  });

  module.exports = Confirmation;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Confirmation.jsx